import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Button from '../../../elements/Button';
import Text from '../../../elements/Text';
import { publish } from '../../../../_integrations/everymundo/tracking/pubsub';

export const ariaDescribeDictionary = {
  FareItemOriginDestination: 'fare-item-origin-destination-',
  FareItemRoute: 'fare-item-route-',
  FareItemDepartureReturnInfo: 'fare-item-departure-return-info-',
  FareItemSaleInfo: 'fare-item-sale-info-',
  FareItemJourneyTypeTravelClass: 'fare-item-journey-type-travel-class-',
  FareItemTripDuration: 'fare-item-trip-duration-',
  FareItemLastSeen: 'fare-item-last-seen-',
  FareItemTags: 'fare-item-tags-',
  FareItemMiles: 'fare-item-miles-',
  FareItemPrice: 'fare-item-price-',
  FareItemAirline: 'fare-item-airline-',
  FareItemDisclaimer: 'fare-item-disclaimer-',
  FareItemCheckRestriction: 'fare-item-check-restriction-'
};

const FareItemCheckRestriction = (props) => {
  const {
    callToAction,
    labelStyles,
    labelKey,
    eventName,
    index,
    enabledDataForSR,
    availableAtoms,
    ...rest
  } = props;

  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  const ariaDescribedBy = availableAtoms
    ?.filter((i) => i !== 'FareItemCheckRestriction')
    ?.map((i) => {
      return `${ariaDescribeDictionary[i]}${index} `;
    });

  return (
    <Button
      className={`call-to-action-button ${className}`}
      dataReactCmpOwner="fareItemCallToAction"
      style={style}
      onClick={(e) => {
        publish(eventName, rest);
        e.stopPropagation();
      }}
      onKeyDown={(e) => {
        e.stopPropagation();
      }}
      alignSelf="end"
      ariaHaspopup="dialog"
      ariaControls="dialog_travel_restriction"
      {...callToAction}
      dataTestId="fareItemCallToAction"
      id={`fare-item-check-restriction-${index}`}
      ariaDescribedBy={enabledDataForSR ? ariaDescribedBy.join(' ') : undefined}
    >
      <Text {...labelStyles} dataReactCmpOwner="fareItemCallToAction">
        {translate(labelKey, 'Check restrictions')}
      </Text>
    </Button>
  );
};

FareItemCheckRestriction.propTypes = {
  /**
   * labelStyles props for using into withStyle.
   */
  labelStyles: PropTypes.objectOf(PropTypes.any),

  callToAction: PropTypes.objectOf(PropTypes.any),
  /**
   * Label Key
   */
  labelKey: PropTypes.string,
  /**
   * Event Name
   */
  eventName: PropTypes.string,
  /**
   * Described atom by the fareItem
   */
  enabledDataForSR: PropTypes.bool
};
FareItemCheckRestriction.defaultProps = {
  labelStyles: {},
  callToAction: {},
  labelKey: 'cmp-fare-item-check-restriction',
  eventName: 'em.travel.restriction.open',
  enabledDataForSR: false
};

FareItemCheckRestriction.componentName = 'FareItemCallToAction';

export default FareItemCheckRestriction;
